import { isEmbroideryMode} from '@/utils/params';

const designIdsKey = () => {
    if (isEmbroideryMode()) {
        return 'uploadedDesignIds-embroidery';
    }
    return 'uploadedDesignIds';
};

function getLocalStorageDesignIds() {
  try {
    return localStorage.getItem(designIdsKey()) || '';
  } catch (e) {
    console.warn('Could not read persisted uploads');
  }

  return '';
}

function setLocalStorageDesignIds(designIds: string) {
  try {
    localStorage.setItem(designIdsKey(), designIds);
  } catch (e) {
    console.warn('Could not persist design ids');
  }
}

function delimitDesignId(designId: string) {
  return `${designId};`;
}

export function getPersistedDesignIds() {
  return getLocalStorageDesignIds().split(';').filter(Boolean).reverse();
}

export function addPersistedDesignId(designId: string) {
  setLocalStorageDesignIds(getLocalStorageDesignIds() + delimitDesignId(designId));
}

export function removePersistedDesignId(designId: string) {
  replacePersistedDesignId(designId, '');
}

export function replacePersistedDesignId(designId: string, newDesignId: string) {
  const storedDesignIds = getLocalStorageDesignIds();
  const delimitedId = delimitDesignId(designId);
  const position = storedDesignIds.indexOf(delimitedId);
  if (position !== -1) {
    setLocalStorageDesignIds(
      storedDesignIds.slice(0, position) +
        delimitDesignId(newDesignId) +
        storedDesignIds.slice(position + delimitedId.length)
    );
  } else if (newDesignId) {
    addPersistedDesignId(newDesignId);
  }
}
